import { API } from '@/config';
import type { RevokeAllSessionsResponse, SystemSettings, UpdateSettingsRequest } from '@/types';
import { api } from './client';

/** Staff-wide security policy and notification toggles - not paginated, so
 *  the plain enveloped client is all this needs. */
export const settingsService = {
  get: (signal?: AbortSignal) => api.get<SystemSettings>(API.endpoints.settings, { signal }),

  update: (body: UpdateSettingsRequest) => api.patch<SystemSettings>(API.endpoints.settings, body),

  revokeAllSessions: () => api.post<RevokeAllSessionsResponse>(API.endpoints.revokeAllSessions),
};
